import { render, staticRenderFns } from "./storyList.vue?vue&type=template&id=c567656c&"
import script from "./storyList.vue?vue&type=script&lang=js&"
export * from "./storyList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\svn\\家用后台\\branches\\20240430-1.5.0\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c567656c')) {
      api.createRecord('c567656c', component.options)
    } else {
      api.reload('c567656c', component.options)
    }
    module.hot.accept("./storyList.vue?vue&type=template&id=c567656c&", function () {
      api.rerender('c567656c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/robot/story/storyList.vue"
export default component.exports